var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModuleWrapper',{attrs:{"instance":_vm.instance}},[_c('div',{class:[(_vm.$appPrefix + "-pi-layer-footer-module")]},[_c('MgsContainer',[_c('MgsRow',[_c('MgsCol',[_vm._v(" PI Layer Footer Module ")])],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }